import { capitalize } from 'lodash';
import { useEffect, useState } from 'react';
import { parseText } from '../utils/text';

const parseTextCache = new Map<string, { html: string; text: string }>();

export const useParseText = (value: string | undefined) => {
	const [values, setValues] = useState<{ html?: string; text?: string }>(
		() =>
			(value ? parseTextCache.get(value) : undefined) ?? {
				html: value,
				text: value,
			},
	);
	useEffect(() => {
		if (!value) return;
		const cached = parseTextCache.get(value);
		if (cached) {
			setValues(cached);
			return;
		}
		let cancelled = false;
		parseText(capitalize(value)).then((html) => {
			if (cancelled) return;
			const element = document.createElement('div');
			element.innerHTML = html;
			const text = element.textContent || element.innerText;
			const result = { html, text };
			parseTextCache.set(value, result);
			setValues(result);
		});
		return () => {
			cancelled = true;
		};
	}, [value]);
	return values;
};
